import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyPage() {
  const { number } = useParams();
  const [state, setState] = useState("loading"); // loading | valid | invalid
  const [cert, setCert] = useState(null);

  useEffect(() => {
    axios.get(`${API}/verify/${number}`)
      .then(({ data }) => { setCert(data); setState("valid"); })
      .catch(() => setState("invalid"));
  }, [number]);

  return (
    <section className="min-h-screen bg-ink-900 text-paper grain flex items-center justify-center px-5 py-32" data-testid="verify-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-xl rounded-sm border border-paper/15 bg-ink-950/60 backdrop-blur p-8 md:p-12 text-center">
        <div className="font-display text-xl font-bold tracking-wide"><span className="text-paper">NOVALEAN</span> <span className="text-gold">CONSULTING</span></div>
        <p className="label-mono text-steel mt-2">Vérification de certificat</p>

        {state === "loading" && <Loader2 size={32} className="animate-spin text-gold mx-auto mt-10" />}

        {state === "valid" && cert && (
          <div data-testid="verify-valid">
            <ShieldCheck size={56} className="text-green-400 mx-auto mt-8" />
            <h1 className="font-display text-3xl md:text-4xl font-semibold text-green-400 mt-4">Certificat authentique</h1>
            <div className="mt-8 text-left space-y-3 border-t border-paper/15 pt-6">
              {[
                ["Nom", cert.user_name],
                ["Formation", cert.course_name],
                ["Date d'obtention", cert.completion_date],
                ["Durée", cert.duration],
                ["Score QCM", `${cert.qcm_score} % (seuil ${cert.passing_score} %)`],
                ["Certificat", cert.certificate_number],
                ["Délivré par", cert.issued_by],
              ].map(([l, v]) => (
                <div key={l} className="flex justify-between gap-4">
                  <span className="label-mono text-paper/45">{l}</span>
                  <span className="text-paper font-medium text-right">{v}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {state === "invalid" && (
          <div data-testid="verify-invalid">
            <ShieldX size={56} className="text-red-400 mx-auto mt-8" />
            <h1 className="font-display text-3xl md:text-4xl font-semibold text-red-400 mt-4">Certificat introuvable ou invalide</h1>
            <p className="text-paper/55 mt-4">Le numéro <span className="font-mono-tech">{number}</span> ne correspond à aucun certificat valide.</p>
          </div>
        )}

        <Link to="/" className="inline-flex items-center gap-2 label-mono text-paper/50 hover:text-gold transition-colors mt-10">novalean-consulting.fr</Link>
      </motion.div>
    </section>
  );
}
